export default "__VITE_ASSET__4e5bi4r4__"